export class EvkFirmaDigitalModel {
    id?: string;
    nombreInterviniente: string;
    leyendaTitulo: string;
    leyendaCuerpo: string;
    documentoNombre: string;
    file?: any;
    minWidth?: number;
    persona?: any;

}
